import React from 'react'
import ReactDOM from 'react-dom'
import Root from './app/root'
import version from './app/version'

ReactDOM.render(<Root/>, document.querySelector(`#render`))
console.log(`version ${version}`) // eslint-disable-line no-console



// WEBPACK FOOTER //
// ./src/index.js